/**
 * Helper method to check if code is being run within our Jest test environment
 */
export const inJestTestEnvironment = (): boolean => {
  return process.env.JEST_WORKER_ID !== undefined
}
